const SHOW_CHAT_BUBBLE_DELAY_MS = 3000;
const CHAT_BUBBLE_VISIBLE_CLASS = "c-chat-bubble--is-visible";
const CHAT_BUBBLE_CONTAINER_HIDDEN_CLASS = "c-chat-bubble__container--is-hidden";

const chatBubbleElement = document.querySelector("[data-chat-bubble]");

const showChatBubble = () => {
  if (!chatBubbleElement) return;

  window.setTimeout(() => {
    chatBubbleElement.classList.add(CHAT_BUBBLE_VISIBLE_CLASS);
  }, SHOW_CHAT_BUBBLE_DELAY_MS);
};

const openChat = () => {
  const chatButton = document.querySelector(".js-open-chat");
  if (!chatButton) return;

  chatButton.addEventListener("click", () => {
    window.ChannelIO?.("openChat");
  });
};

const closeChatBubble = () => {
  const closeButton = document.querySelector(".js-close-chat");
  if (!closeButton) return;

  closeButton.addEventListener("click", () => {
    chatBubbleElement
      ?.querySelector(".c-chat-bubble__container")
      ?.classList.add(CHAT_BUBBLE_CONTAINER_HIDDEN_CLASS);
  });
};

export const initChannelTalk = () => {
  document.addEventListener("click", (e) => {
    if (!chatBubbleElement) return;
    if (!(e.target as HTMLElement).closest(".js-chat-bubble, .js-open-chat"))
      return;
    if (typeof window.ChannelIO !== "function") return;

    window.ChannelIO?.("showMessenger");
    chatBubbleElement.classList.remove(CHAT_BUBBLE_VISIBLE_CLASS);

    window.ChannelIO?.("onShowMessenger", () => {
      chatBubbleElement.classList.remove(CHAT_BUBBLE_VISIBLE_CLASS);
    });

    window.ChannelIO?.("onHideMessenger", () => {
      chatBubbleElement.classList.add(CHAT_BUBBLE_VISIBLE_CLASS);
    });
  });

  showChatBubble();

  openChat();

  closeChatBubble();
};
